import { ref } from 'vue'
import axios, { type AxiosResponse } from 'axios'
import type { ApiError, FetchOptions } from '@/utils/types'
import { FALLBACK_API_ERROR } from '@/utils/consts'
import type { AlertsResponse, SortOrder } from '@/services/alerts-v2-service/types'

export const createAlertsBase = <TAlert, TAlerts, TFilters, TSortingKey>(
  initParams: Record<string, any>, // eslint-disable-line
  fetchFucntion: (
    a: number,
    b: TFilters,
    c: TSortingKey,
    d: SortOrder,
  ) => Promise<AxiosResponse<TAlerts>>,
) => {
  const loading = ref(true)
  const error = ref<ApiError | null>()
  const page = ref(1)
  const pages = ref(0)
  const pageSize = ref(10)
  const alerts = ref<TAlert[]>()
  const filters = ref<TFilters>()
  const sortBy = ref(initParams.sortBy ?? null)
  const sortOrder = ref(-1)

  const clear = () => {
    loading.value = true
    alerts.value = []
  }

  const fetch = async (page: number, opts: FetchOptions = {}) => {
    if (!opts.keepState) {
      loading.value = true
    }
    const filtersToSend = {
      ...filters.value,
    } as TFilters
    try {
      const req = await fetchFucntion(
        page,
        filtersToSend,
        sortBy.value as TSortingKey,
        sortOrder.value == -1 ? 'desc' : 'asc',
      )
      const data = req.data as AlertsResponse<TAlert>
      alerts.value = data.alerts
      pages.value = data.pages
      pageSize.value = data.page_size
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        error.value = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        error.value = FALLBACK_API_ERROR
      }
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    alerts,
    page,
    filters,
    pages,
    pageSize,
    fetch,
    sortBy,
    clear,
    sortOrder,
  }
}
